import AppRoute from "models/AppRoute"

const ShippingOrdersRoute = new AppRoute({
    route: "/shipping-orders",
    navbar: true,
    authRequired: true,
})

export default ShippingOrdersRoute
